<!--
 * @Author: LiuChuanQi
 * @Date: 2022-11-25 15:37:34
 * @LastEditTime: 2023-03-02 14:59:23
 * @LastEditors: LiuChuanQi
 * @Description: 大数据全局登录弹窗
 * @FilePath: \speedtest-bigdata-v2\src\components\common\login\login.vue
 *
-->
<template>
  <div
    class="login-view"
    v-if="active"
  >
    <div
      class="longin-content"
      v-if="!showRegister&&!showSetInfor"
    >
      <div
        class="close-icon"
        @click.stop="closeLogin"
      ></div>
      <div class="top-tab">
        <span
          class="tab-item"
          :class="{'active':activeTab===0}"
          @click.stop="changeTab(0)"
        >账号登录</span>
        <span
          class="tab-item"
          :class="{'active':activeTab===1}"
          @click.stop="changeTab(1)"
        >短信登录</span>
      </div>
      <password-type
        v-if="activeTab===0"
        :showRegister.sync="showRegister"
        :loginScuess.sync="loginScuess"
        :isShowInfor.sync="isShowInfor"
      ></password-type>
      <sms-type
        v-else
        :showRegister.sync="showRegister"
        :isFirstLogin.sync="isFirstLogin"
        :loginScuess.sync="loginScuess"
        :firstLoginCode.sync="firstLoginCode"
        :firstLoginPhone.sync="firstLoginPhone"
        :isShowInfor.sync="isShowInfor"
      ></sms-type>
    </div>
    <register
      v-if="showRegister"
      :showRegister.sync="showRegister"
      :isShowInfor.sync="isShowInfor"
      :isShowInfor2.sync="isShowInfor2"
    ></register>
    <first-login
      v-if="showSetInfor"
      :isFirstLogin.sync="isFirstLogin"
      :loginScuess.sync="loginScuess"
      :showSetInfor.sync="showSetInfor"
      :firstLoginCode.sync="firstLoginCode"
      :firstLoginPhone.sync="firstLoginPhone"
    ></first-login>
    <transition name="toast">
      <div
        class="my-toast"
        v-show="isShowInfor"
      >请先同意用户协议</div>
    </transition>

    <transition name="toast">
      <div
        class="my-toast"
        v-show="isShowInfor2"
      >注册成功</div>
    </transition>
  </div>
</template>

<script>
import PasswordType from './PasswordType.vue'
import SmsType from './SmsType.vue'
import register from './register.vue'
import FirstLogin from './FirstLogin.vue'
import jwtDecode from 'jwt-decode'
import store from '@/store/index'
export default {
  components: {
    PasswordType,
    SmsType,
    register,
    FirstLogin
  },
  data() {
    return {
      active: false, //控制弹窗是否激活
      activeTab: 0, //默认的登录模式
      showRegister: false, //是否显示登录弹窗
      showSetInfor: false, //显示设置信息弹窗
      isFirstLogin: false, //是否时第一次登录
      loginScuess: false, //是否登录成功
      firstLoginCode: '', //第一次手机号登录验证码
      firstLoginPhone: '', //第一次手机号登录验证码
      isShowInfor: false, //是否显示约定须知
      isShowInfor2: false //是否显示注册成功
    }
  },
  methods: {
    open() {
      this.active = true
    },
    closeLogin() {
      this.active = false
      this.activeTab = 0
    },
    changeTab(index) {
      this.activeTab = index
    }
  },
  mounted() {
    //document.body.style.overflow = 'hidden'
  },
  destroyed() {
    //document.body.style.overflow = 'auto'
  },
  watch: {
    loginScuess: {
      handler(newval) {
        if (newval) {
          if (this.isFirstLogin) {
            //登录成功且是第一次登录
            this.showSetInfor = true
          } else {
            //登录成功 关闭弹窗
            try {
              const infor = jwtDecode(store.getters['login/getToken'])
              //是否有会员权限
              if (infor.roles && infor.roles[0] && infor.roles[0].roleId === 1 && infor.roles[0].effectEndDate > new Date().getTime()) {
                store.commit('login/setValue', [true, 'is_member'])
                store.commit('login/setValue', [infor.roles[0].effectEndDate, 'effect_end_date'])
              } else if(infor.roles && infor.roles[1] && infor.roles[0].roleId === 2) {
              }
            } catch (error) {}
            this.showSetInfor = false
            this.active = false
            let currentRoute = this.$myVue.$route.path
            const whiteList = ['/', '/realtime', '/operators', '/ranks', '/map/speed', '/map/signal', '/back-password', '/pay-member']
            if (whiteList.includes(currentRoute)) {
              location.href = location.href
            } else {
              location.href = '/'
            }
          }
        }
      },
      deep: true
    },
    isFirstLogin: {
      handler(newval) {
        if (newval) {
          this.showSetInfor = true
        } else {
        }
      }
    },
    isShowInfor2: {
      handler(newval) {
        if (newval) {
          setTimeout(() => {
            this.isShowInfor2 = false
          }, 2000)
        } else {
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.login-view {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 99;
  .longin-content {
    width: 382px;
    min-height: 314px;
    background: rgba(11, 25, 66, 0.9);
    border-radius: 8px;
    border: 1px solid #00d2fa;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    padding: 40px 56px 13px;
    box-sizing: border-box;
    .close-icon {
      width: 14px;
      height: 14px;
      background: url(@/assets/image/icon/closeLogin.png);
      background-size: 100%;
      position: absolute;
      right: 16px;
      top: 16px;
      cursor: pointer;
    }
    .top-tab {
      overflow: hidden;
      .tab-item {
        float: left;
        height: 29px;
        position: relative;
        margin-right: 39px;
        line-height: 22px;
        font-size: 14px;
        color: #82889a;
        cursor: pointer;
        &.active {
          font-weight: bold;
          color: #fff;
          cursor: none;
          &::after {
            content: '';
            display: block;
            position: absolute;
            width: 100%;
            height: 2px;
            background-color: #fff;
            top: 27px;
            left: 0;
          }
        }
      }
    }
  }
}
.my-toast {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: calc(50% - 340px);
  padding: 10px 30px;
  box-sizing: border-box;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 20px;
  font-size: 14px;
  z-index: 100;
  background: rgba(11,25,66,0.9);
  border: 1px solid #00D2FA;
}
.toast-enter-active {
  animation: bounce-in 0.5s
}

.toast-leave-active {
  //animation: bounce-in 0.5s reverse
}
@keyframes bounce-in {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
}
</style>
